import React from "react";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";

import "../styles/Home.css";

const Home = () => {
  return (
    <div className="home">
      <div className="home_content">
        <h3>
          Hi, I'm <br /> Keyur
        </h3>
        <p>I am a Front End Dev and Blockchain Enthusiast</p>
        <div className="buttons">
          <button>
            <ScrollLink to="projects" smooth={true} duration={500}>
              My Projects
            </ScrollLink>
          </button>
          <button>Let's Connect</button>
        </div>
      </div>
    </div>
  );
};

export default Home;
